export const useResetMiteSteps = () => {
  // TODO: реализовать логику выставления значений по умолчанию на шагах
  return null;
};
